import { useContext } from 'react';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetCertificateAuthoritiesAvailableCertificateAuthoritiesDto as AuthoritiesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { Loadable } from '../../types';
import { AuthoritiesContext } from '../contexts/AuthoritiesContext';

export const useAuthorities = (): Loadable<AuthoritiesDto[]> => {
  const context = useContext(AuthoritiesContext);

  return context;
};
